export const paginationMixin = {
  data() {
    return {
      pagination: {
        rowsPerPage: +this.$route.query.limit || 10,
        page: +this.$route.query.page || 1,
      },
      pageKey: null,
    };
  },
  computed: {
    options: {
      get() {
        return {
          page: this.pagination.page,
          itemsPerPage: this.pagination.rowsPerPage,
          sortBy: this.pagination.sortBy
            ? [{ key: this.pagination.sortBy, order: this.pagination.descending ? 'desc' : 'asc' }]
            : [],
        };
      },
      set(options) {
        const [sort] = options.sortBy || [];
        this.pagination = {
          ...this.pagination,
          page: options.page,
          rowsPerPage: options.itemsPerPage,
          sortBy: sort ? sort.key : undefined,
          descending: sort ? sort.order === 'desc' : undefined,
        };
      },
    },
    tableSortBy: {
      get() {
        return this.pagination.sortBy
          ? [{ key: this.pagination.sortBy, order: this.pagination.descending ? 'desc' : 'asc' }]
          : [];
      },
      set(sortBy) {
        const [sort] = sortBy || [];
        this.pagination = {
          ...this.pagination,
          sortBy: sort ? sort.key : undefined,
          descending: sort ? sort.order === 'desc' : undefined,
        };
      },
    },
    getPaginationQuery() {
      return `?limit=${this.pagination.rowsPerPage}&page=${this.pagination.page}`;
    },
  },
  watch: {
    pagination: {
      handler() {
        if (this.pageKey) {
          localStorage.setItem(`userPaging.${this.pageKey}.perPage`, `${this.pagination.rowsPerPage}`);
        }
      },
      deep: true,
    },
  },
  mounted() {
    const storedPerPage = parseInt(localStorage.getItem(`userPaging.${this.pageKey}.perPage`));
    if (!this.pagination) {
      this.pagination = {};
    }
    this.pagination.rowsPerPage = +this.$route.query.limit || storedPerPage || 10;
    this.pagination.page = +this.$route.query.page || 1;
  },
  methods: {},
};
